import React from 'react';

export default function useModalMinHeightFix(ref, differ) {
  const [minHeight, setMinHeight] = React.useState(0);
  React.useEffect(() => {
    if (ref.current) {
      if (minHeight === 0) {
        setMinHeight(ref.current.getBoundingClientRect().height);
      } else {
        setMinHeight(0);
      }
    }
  }, [differ]);

  return minHeight;
}
